export default [
    {
        // [0]
        key: "code",
        label: app.$i18n.t("Code"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "name",
        label: app.$i18n.t("Description"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "transaction_type",
        label: app.$i18n.t("Type"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        sortable: true,
        visible: true,
    },
    {
        // [13]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]